export default __webpack_public_path__ + "static/media/serverReceived.0bd09676.mp3";